/**
 * 개인위치정보 수집·이용 동의 (Location Information Consent) - 한국어 v1
 * 
 * 위치기반서비스(LBS) 한국 법적 요구사항에 따른 동의서
 */
export const LOCATION_V1_KO = {
    version: "v1",
    effectiveDate: "2026-01-16",
    language: "ko",
    title: "개인위치정보 수집·이용 동의",
    content: `
개인위치정보 수집·이용 동의

Spot Go("서비스")는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라 개인위치정보를 수집·이용합니다. 서비스 이용을 위해 아래 내용을 확인하시고 동의해 주시기 바랍니다.

1. 위치정보 수집자

서비스명: Spot Go
연락처: lukep81@painori.com

2. 수집하는 위치정보 항목

• GPS 기반 실시간 위치정보 (위도, 경도)
• WiFi/기지국 기반 대략적 위치정보
• 위치 정확도 정보

3. 위치정보의 이용 목적

• 주변 매장 및 게시물 검색
• 위치 기반 콘텐츠 표시 및 추천
• 매장/게시물 등록 시 위치 자동 입력
• 지도 서비스 제공 (네이버 지도, Leaflet)
• 서비스 이용 통계 분석

4. 위치정보의 보유 및 이용 기간

• 실시간 위치: 서비스 이용 중에만 활용되며, 서버에 저장되지 않습니다.
• 위치 기반 게시물: 게시물에 포함된 위치 정보는 해당 게시물과 함께 보관됩니다.
• 계정 탈퇴 시: 모든 위치 관련 데이터가 즉시 삭제됩니다.

5. 위치정보의 제3자 제공

원칙적으로 제3자에게 제공하지 않습니다.

예외 사항:
• 법령에 의해 요구되는 경우
• 지도 서비스 제공을 위한 외부 API 호출 시 (네이버, Leaflet)

6. 이용자의 권리

• 위치정보 수집·이용 동의를 언제든지 철회할 수 있습니다.
• 동의 철회 시 위치 기반 서비스 이용이 제한됩니다.
• 문의: lukep81@painori.com

7. 위치정보 관리책임자

연락처: lukep81@painori.com

⚠️ 중요 안내

Spot Go는 위치기반 서비스입니다. 위치정보 수집에 동의하지 않으시면 다음과 같은 핵심 기능을 이용하실 수 없습니다:

• 주변 스팟(매장/게시물) 검색
• 새 게시물 및 매장 등록
• 지도 기반 탐색

동의하시면 브라우저의 위치 권한 요청이 표시됩니다.
`.trim()
};
